<aside id="mainComponent"
  [ngClass]="{'vh-100': authService.sessionActive() && termsAndConditionsActive, 'header-with-alert': hasGpsAlert}">
  <div id="mainHeader">
    <app-header [rndcContingency]="rndcContingency"
      (gpsAlertVisibilityChange)="onGpsAlertVisibilityChange($event)"></app-header>
  </div>
  <div id="mainBody"
    [ngClass]="{'body-grid':authService.sessionActive() && termsAndConditionsActive, 'nav-hide': navCollapse && !navHover, 'body-grid--hover': !navCollapse && navHover}">
    <div id="navHamburger" (mouseenter)="mouseEvent($event)" (mouseleave)="mouseEvent($event)"
      *ngIf="authService.sessionActive() && termsAndConditionsActive">
      <app-nav [orientation]="'vertical'"></app-nav>
    </div>
    <div id="content">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div id="footer" *ngIf="!authService.sessionActive()">
    <app-footer></app-footer>
  </div>
</aside>


<img class="btn__wa" *ngIf="isOutOfCargoCreate && !authService.sessionActive()" src="/assets/img/whatsapp_icon.png"
  width="44" height="44" alt="Whatsapp" (click)="goToWA()">

<button type="button" class="btn-search-fab" *ngIf="showSearchFab" matTooltip="Localizar en LoggiApp"
  (click)="goToCargoSearch()">
  <i class="fas fa-search"></i>
</button>
